export const errorMsg = {
  color: 'red',
  fontStyle: 'italic',
  fontSize: '10px',
  textAlign: 'right',
};
